import { IPrebidAdUnit } from '../../typings/IPrebid'
import { Bidder } from '../enums'
import { deepcopy } from '../helpers/deepcopy'
import { Device } from '../helpers/Device'
import { Slot } from '../slots/Slot'

/**
 * Adds outstream bid requests to slot if
 * it hasn't rendered more times than allowed.
 */

export const hasOutstream = (target: Constructor<Slot>): any =>
  // @ts-ignore
  class extends target {
    validate(): boolean {
      return super.validate()
    }

    adunits(): Array<IPrebidAdUnit> {
      const adunits: Array<IPrebidAdUnit> = []
      adunits.push(...super.adunits())

      const outstreamAdunit = this.getOutstreamAdunit()

      if (meetsOutstreamCriteria(this) && outstreamAdunit) {
        adunits.push(outstreamAdunit)
      }

      return adunits
    }

    getOutstreamAdunit(): IPrebidAdUnit | undefined {
      let adunitName
      let bidRequestKey
      if (Device.isMobileOrTablet) {
        bidRequestKey = `${this.slotName}_outstream_mobile`
        adunitName = `${this.slotName}_${this.number}_outstream_mobile`
      } else {
        bidRequestKey = `${this.slotName}_outstream_desktop`
        adunitName = `${this.slotName}_${this.number}_outstream_desktop`
      }

      const bidRequests = this.model.bidRequests[bidRequestKey]
      if (!bidRequests) {
        return undefined
      }
      const outstreamBidRequests = deepcopy(
        bidRequests,
        'Error copying outstream bid requests'
      )

      if (!outstreamBidRequests) {
        return undefined
      }

      outstreamBidRequests.map((bid) => {
        bid.isOutstream = true
        bid.outstreamAdUnitCode = adunitName
        // Set GumGum's selector
        if (bid.bidder === Bidder.gumgum_icv) {
          bid.params.selector = this.id
        }
      })

      const outstreamSizes = getOutstreamSizes(this) as AdSize[]
      return {
        code: adunitName, // this.id,
        bids: outstreamBidRequests,
        sizes: outstreamSizes,
        mediaTypes: {
          video: {
            context: 'outstream',
            playerSize: outstreamSizes[0]
          },
          banner: {
            sizes: outstreamSizes
          }
        }
      }
    }
  }

function meetsOutstreamCriteria(slot: Slot): boolean {
  switch (slot.slotName) {
    case 'content':
      return contentCriteria(slot)
    case 'recipe':
      return recipeCriteria(slot)
    default:
      // Default to the contentCriteria, I guess.
      return contentCriteria(slot)
  }
}

function getOutstreamSizes(slot: Slot): AdSizes {
  switch (slot.slotName) {
    case 'content':
      return [[1, 1]]
    case 'recipe':
      return slot.sizes
    default:
      return slot.sizes
  }
}

function contentCriteria(slot: Slot): boolean {
  const number = slot.number
  // skip first slot
  return (
    number !== 1 &&
    // only render every other slot
    number % 2 === 0
  )
}

function recipeCriteria(slot: Slot): boolean {
  const number = slot.number
  // render only in odd slots.
  return number % 2 !== 0
}
